export const requestUrl = {
  backendUrl: 'api/'
};
